import { forwardRef } from 'react';
import { cx } from '@emotion/css';
import { FormLabel } from '@mui/material';

import { FieldGroupProps } from './types';
import { fieldGroupCx } from './styles';

const FieldGroup = forwardRef<HTMLDivElement, FieldGroupProps>((props, ref) => {
  const {
    children,
    footer,
    label,
    name,
    className,
    invalid,
    error,
    helperText,
  } = props;

  const errorMessage: string | string[] | undefined = error?.message;

  return (
    <div ref={ref} className={cx('field-group', className, fieldGroupCx)}>
      {Boolean(label) && (
        <FormLabel className='field-label' htmlFor={name}>
          {label}
        </FormLabel>
      )}
      {children}
      {((invalid && Boolean(error?.message)) || helperText) && (
        <div className='field-info'>
          {invalid && error?.message ? (
            <div className='error field-info-item'>
              {Array.isArray(errorMessage) && errorMessage.length > 0 ? (
                <ul>
                  {errorMessage.map((msg, index) => (
                    <li key={index}>{msg}</li>
                  ))}
                </ul>
              ) : (
                <span>{errorMessage}</span>
              )}
            </div>
          ) : (
            helperText && (
              <div className='helper field-info-item'>
                <span>{helperText}</span>
              </div>
            )
          )}
        </div>
      )}
      {footer}
    </div>
  );
});

export default FieldGroup;
